import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeagueHomeComponent } from './league-home.component';
import { RouterModule } from '@angular/router';
import { ROUTES } from './league-home.routes';
import { NewsSliderComponent } from './news-slider/news-slider.component';
import { ButtonModule, DataSliderModule, ProgressModule, ShareModule, SvgIconModule, UtilsModule } from '@mtgame/ui';
import { BannersSliderComponent } from './banners-slider/banners-slider.component';
import { NewsListComponent } from './news-list/news-list.component';
import { PartnersListComponent } from './partners-list/partners-list.component';
import { LeagueGamesSliderComponent } from './league-games-slider/league-games-slider.component';
import { LeagueLiveComponent } from './league-live/league-live.component';
import { LeagueVideoComponent } from './league-video/league-video.component';
import { LeaguePhotosComponent } from './league-photos/league-photos.component';
import { TournamentMediaModule } from '../../../shared/tournament-media/tournament-media.module';
import { GamesSliderModule } from '../../../shared/games-slider/games-slider.module';
import { SharedModule } from '@shared/shared.module';
import { VideoDetailComponent } from './video-detail/video-detail.component';
import { PhotoDetailComponent } from './league-photos/photo-detail.component';
import { TournamentWidgetModule } from '../../../shared/tournament-widget/tournament-widget.module';
import { TournamentStageWidgetModule } from '../../../shared/tournament-stage-widget/tournament-stage-widget.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    SvgIconModule,
    DataSliderModule,
    ProgressModule,
    UtilsModule,
    TournamentMediaModule,
    GamesSliderModule,
    SharedModule,
    ButtonModule,
    ShareModule,
    TournamentWidgetModule,
    TournamentStageWidgetModule,
  ],
  declarations: [
    LeagueHomeComponent,
    NewsSliderComponent,
    BannersSliderComponent,
    NewsListComponent,
    PartnersListComponent,
    LeagueGamesSliderComponent,
    LeagueLiveComponent,
    LeagueVideoComponent,
    LeaguePhotosComponent,
    VideoDetailComponent,
    PhotoDetailComponent,
  ]
})
export class LeagueHomeModule {}
